<template>
    <div :class="prefix">
        <div :class="prefix + '-title'">
            {{title}}
        </div>
        <div v-if="title === '全文解读'" :class="prefix + 'content'">
            {{ data.summary }}
        </div>
        <div v-else-if="title === '胸部影像学检查'">
            <div class="ct" v-if="data.ct_display">
                <div class="title">CT</div>
                <div class="content" >
                    <div v-for="data in data.ct_display" :key="data.name">
                        <div class="c_title">{{data.name}}</div>
                        <div> {{ data.values}}</div>
                    </div>
                </div>
            </div>
             <div class="ct"  v-if="data.x_ray_display">
                <div class="title">X光</div>
                <div class="content">
                    <div v-for="data in data.x_ray_display" :key="data.name">
                        <div class="c_title">{{data.name}}</div>
                        <div> {{ data.values}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div  v-else-if='title === "基线特征"'>
             <div v-for="(item,index) in rows" :key='index' :class="prefix + '-row'" v-show="item.key && data[item.key]">
                <div class="title">
                    {{item.title}}
                </div>
                <div class='value'>
                    {{item.key && data[item.key]}}
                </div>
            </div>
            <div  :class="prefix + '-row'" style="flex-wrap: wrap;" v-if="Array.isArray(data.gender_display)">
                <div class="title" style="min-width:100%"> 性别 </div>
                <div class="gender">
                    <i class="iconfont" style="color:#3DB1E6" v-show="data.gender_display[0].proportion">&#xe7fd;</i>
                    <div :class="{'man-no-radius':data.gender_display[0].proportion >= 100 ? false : true,'man':true}" :style="{width:`${data.gender_display[0].proportion}%`}">
                        {{`${data.gender_display[0].values} (${data.gender_display[0].proportion}%)`}}
                    </div>
                    <div :class="{'woman-no-radius':data.gender_display[1].proportion >= 100 ? false : true,'woman':true }" :style="{width:`${data.gender_display[1].proportion}%`}">
                        {{`${data.gender_display[1].values} (${data.gender_display[1].proportion}%)`}}
                    </div>
                    <i class="iconfont" style="color:#FFA558" v-show="data.gender_display[1].proportion">&#xe7fe;</i>
                </div>
            </div>
        </div>
        <template v-else-if="title === '实验室检查'" v-show="data.laboratory_find_display.length">
            <Table :columns='columns' :data='data.laboratory_find_display' border/>
        </template>
        <div v-else-if="title === '治疗方案'" :class="prefix + '-row-group'">
            <div  v-for="(item,index) in rows" :key='index' class="row" v-show="item.key && data[item.key]" > 
                <div class="r-title">{{item.title}}</div>       
                <div class="r-value">{{data[item.key]}}</div>            
            </div>
        </div>
         <div v-for="(item,index) in rows" :key='index' :class="prefix + '-row'" v-else v-show="item.key && data[item.key]">
           <div class="title" >
                {{item.title}}
           </div>
           <div class='value'>
                {{item.key && data[item.key]}}
           </div>
        </div>
    </div>
</template>
<script>
const prefix = 'academicLiteratureDetailCard'
export default {
    data() {
        return {
            man:require('src/assets/images/man.png'),
            woman:require('src/assets/images/woman.png'),
            prefix:prefix,
            columns:[
                {
                    title:'检查指标',
                    width:200,
                    render:(h,params)=>{
                        return <div style="font-size:12px;">{params.row.name.join('')}</div>
                    }
                },
                {
                    title:'总数',
                    width:100,
                    key:'sum'

                },
                {
                    title:'升高',
                    width:100,
                    key:'down'
                },
                {
                    title:'下降',
                    width:100,
                    key:'up'
                },
            ]
        }
    },
    props:{
        title:{
            type:String,
            default:''
        },
        data:{
            type:Object,
            default:()=>{}
        },
        rows:{
            type:Array,
            default:()=>[]
        }
    },

}
</script>
<style lang="less" scoped>
.academicLiteratureDetailCard{
    padding:0.2rem 0.16rem;
    background-color:#ffffff;
    cursor: pointer;
    margin-top:0.08rem;
    &-title{
        font-size:20px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:600;
        color:rgba(51,51,51,1);
        position: relative;
        padding-left:0.1rem;
        margin-bottom: 0.23rem;
    }
    &-title::before{
        content: '';
        position: absolute;
        left: 0;
        top: 10%;
        width:0.03rem;
        height: 80%;
        background:rgba(254,121,34,1);

    }
  
    &-row{
        display:flex;
        align-items: center;
        justify-content:space-between;
        margin-bottom:0.2rem;
        font-size: 14px;
        .title{
            color: #8D99A6;
        }
        .value{
            color: #333333;
        }
       
        .gender{
            display:flex;
            align-items: center;
            width: 100%;
            overflow: hidden;
            
            >div{
                height: 24px;
                width:50%;
                text-indent:8px;
                color: #ffffff;
                font-size: 13px;
                line-height:24px;
                border-radius: 3px;
            }
            .man{
                width: 40%;
                background:rgba(61,177,230,1);
               
            }
            .woman{
                width: 40%;
                background:rgba(255,165,88,1);
             
            }
            .woman-no-radius{
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;

            }
             .man-no-radius{
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;

            }
        }
     
    }
    &-row-group{  
        display:flex;
        flex-wrap: wrap;
        flex-direction: row;
                        border: 1px solid rgba(239,239,239,1);

        .row{
            display:inline-block;
            width:50%;
            height: 60px;
            display:inline-block;
            justify-content:space-between;
            text-align: center;
             .r-title{
                color: #999999;
                font-size: 14px; 
                background:rgba(248,248,248,1);
                font-size: 12px;
                height: 100%;
                float: left;
                padding:0 8px;
                display:flex;
                justify-content:center;
                align-items:center;
                border-right:1px solid rgba(239,239,239,1);
                border-bottom:1px solid rgba(239,239,239,1);

            }
            .r-value {
                float: left;
                display:flex;
                justify-content:center;
                align-items:center;
                border-right:1px solid rgba(239,239,239,1);
                border-bottom:1px solid rgba(239,239,239,1);
                border-left: none

            }
            >div{
                display:inline-block;
                width:50%;
                height: 100%;
            }
            .t-value{
                color: #333333;

            }
        }
    }
    .ct{
        .title{
            font-size:14px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(141,153,166,1);
        }
        .content{
            background:rgba(248,248,248,1);
            border-radius:3px;
            min-height: 70px;
            padding:0.12rem 0.1rem;
            .c_title{
                font-size:14px;
                font-family:PingFangSC-Medium,PingFang SC;
                font-weight:500;
                color:rgba(51,51,51,1);
            }
           
        }
    }
}
</style>